import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./redux/features/authSlice";
import notificationReducer from "./redux/features/notificationSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    notifications: notificationReducer,
  },
  devTools: true,
});

export default store;
